import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { isDarkTheme } from "helpers/darkTheme";

export default function Divider() {
  return <Hr />;
}

const Hr = styled(Box)(({ theme }) => ({
  height: "2px",
  position: "relative",
  margin: "0.15rem 0",

  "&:before": {
    content: "''",
    position: "absolute",
    width: "100%",
    height: "1px",
    backgroundImage: `linear-gradient(to right, ${isDarkTheme(theme.palette.mode) ? "rgba(173, 188, 193, 0.6)" : "rgba(0, 0, 0, 0.6)"}, transparent, ${isDarkTheme(theme.palette.mode) ? "rgba(173, 188, 193, 0.6)" : "rgba(0, 0, 0, 0.6)"})`,
  },
}));
